import { companyApi, companyTemplateApi } from 'app/services/api';
import _ from 'lodash';
import { normalize, schema } from 'normalizr';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const COMPANIES_ACTION_TYPE = createNamedActions('companies', {
  GET_COMPANIES: 'GET_COMPANIES',
  GET_COMPANY: 'GET_COMPANY',
  CREATE_COMPANY: 'CREATE_COMPANY',
  EDIT_COMPANY: 'EDIT_COMPANY',
  DELETE_COMPANY: 'DELETE_COMPANY',
});

const companySchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getCompaniesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyApi.getCompanies(params);

  return dispatch({
    type: COMPANIES_ACTION_TYPE.GET_COMPANIES,
    payload: normalize(data, [companySchema]).entities.data,
  });
});

export const getCompanyAction = catchAsyncActionError(({ companyId }) => async dispatch => {
  const { data } = await companyApi.getCompany({ companyId });

  return dispatch({
    type: COMPANIES_ACTION_TYPE.GET_COMPANY,
    payload: data,
  });
});

export const createCompanyAction = catchAsyncActionError(params => async (dispatch, getState) => {
  const state = getState();

  const isTestModeForTemplateCompanyOff = selectFeatureFlagByKey(
    FeatureFlag.IsTestModeForTemplateCompanyOff,
  )(state);

  const isFromTemplateCompany = !!params.templateCompanyId;

  const { data } = await (isFromTemplateCompany
    ? companyTemplateApi.createFromTemplateCompany({
        ...params,
        testMode: !isTestModeForTemplateCompanyOff,
      })
    : companyApi.createCompany(params));

  return dispatch({
    type: COMPANIES_ACTION_TYPE.CREATE_COMPANY,
    payload: isFromTemplateCompany ? data.company : data,
    meta: isFromTemplateCompany ? _.omit(data, 'company') : {},
  });
});

export const editCompanyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyApi.editCompany(params);

  return dispatch({
    type: COMPANIES_ACTION_TYPE.EDIT_COMPANY,
    payload: data,
  });
});

export const deleteCompanyAction = catchAsyncActionError(params => async dispatch => {
  await companyApi.deleteCompany(params);

  return dispatch({
    type: COMPANIES_ACTION_TYPE.DELETE_COMPANY,
    meta: params,
  });
});
